import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useGetOne, useNotify } from 'react-admin';
import { DeleteDialog, DeleteDialogProps } from 'shared/mui/Dialogs';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { Currency } from 'types/embedded/currency';
import { Gateway } from 'types/embedded/gateway';

export const MerchantsShowLimitsDeleteDialog: React.FC<
  Omit<DeleteDialogProps, 'details' | 'title'>
> = (props) => {
  const translate = useTypedTranslate();
  const notify = useNotify();

  const currency = useGetOne<Currency>(Resources.Currencies, {
    id: props.record?.currency?.['@id'],
  });
  const gateway = useGetOne<Gateway>(Resources.Gateways, { id: props.record?.gateway?.['@id'] });

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: ['limit'] });
    props.onClose();
    notify(translate('app.limits.limitDeletedSuccess'), {
      type: 'success',
    });
  };

  return (
    <DeleteDialog
      {...props}
      details={
        <>
          {translate('app.limits.gatewayCurrencyLimit1', {
            currencyName: currency.data?.name,
          })}{' '}
          <TypographyBold fontSize={16} text={gateway.data?.name || ''} />{' '}
          {translate('app.limits.gatewayCurrencyLimit2')}
        </>
      }
      onSuccess={onSuccess}
      title={translate('app.limits.deleteLimit')}
    />
  );
};
